import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="m6.667 10.833 3.333 3.334 3.333-3.334m0-1.666L10 5.833 6.667 9.167"
    />
  </svg>
);

export { SvgComponent as ChevronUpDownIcon };

